import { render } from "./ciudadesDetail.vue?vue&type=template&id=a135c4fe"
import script from "./ciudadesDetail.vue?vue&type=script&lang=js"
export * from "./ciudadesDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__